// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__SBhwU","colBig":"styles_colBig__2Wcob","colSmall":"styles_colSmall__3iQMb"};